import React, { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";

// Package Type choices. "Custom…" lets a director type any word instead of being forced into
// "Other" — the backend accepts any text here, this list is just a shortcut for common ones.
export const PRESET_UNIT_TYPES = [
  { value: "bag", label: "Bag" }, { value: "can", label: "Can" },
  { value: "case", label: "Case" }, { value: "box", label: "Box" },
  { value: "jar", label: "Jar" }, { value: "bottle", label: "Bottle" },
  { value: "other", label: "Other" },
];
const CUSTOM_VALUE = "__custom__";

export const UnitTypeSelect = ({ value, onChange, testId, triggerClassName = "w-28" }) => {
  const isPreset = PRESET_UNIT_TYPES.some((u) => u.value === value);
  const [showCustomInput, setShowCustomInput] = useState(!!value && !isPreset);

  return (
    <div className="flex items-center gap-1">
      <Select
        value={showCustomInput ? CUSTOM_VALUE : (value || "bag")}
        onValueChange={(v) => {
          if (v === CUSTOM_VALUE) {
            setShowCustomInput(true);
            onChange("");
          } else {
            setShowCustomInput(false);
            onChange(v);
          }
        }}
      >
        <SelectTrigger className={triggerClassName} data-testid={testId}><SelectValue /></SelectTrigger>
        <SelectContent>
          {PRESET_UNIT_TYPES.map((u) => <SelectItem key={u.value} value={u.value}>{u.label}</SelectItem>)}
          <SelectItem value={CUSTOM_VALUE}>Custom…</SelectItem>
        </SelectContent>
      </Select>
      {showCustomInput && (
        <Input value={value || ""} onChange={(e) => onChange(e.target.value)}
          placeholder="Type package type" className="h-8 w-32" data-testid={`${testId}-custom-input`} />
      )}
    </div>
  );
};
